export const profilMapping = {
  'Marche' : {
    'Forte endurance': 'basic_pedestrian',
    'Endurance normale': 'basic_pedestrian',
    'Marche difficilement': 'walking_impaired_user'
  },
  'Déficience motrice': {
    'Fauteuil roulant électrique': 'electric_wheelchair_user',
    'Fauteuil roulant manuel': 'manual_wheelchair_user'
  },
  'Déficience visuelle': {
    'Partielle (malvoyant)': 'visually_impaired_user',
    'Totale (non-voyant)': 'blind_user'
  },
  'Déficience auditive': {
    'Partielle (malentendant)': 'hearing_impaired_user',
    'Totale (sourd)': 'deaf_user'
  },
  'Déficience mentale': {
    'Trouble intellectuel': 'intellectually_disabled_user',
    'Trouble psychique': 'cognitively_impaired_user',
  }
};

export const profilMappingVal = {
  'Marche' : {
    'Forte endurance': 'walking',
    'Endurance normale': 'walking',
    'Marche difficilement': 'md'
  },
  'Déficience motrice': {
    'Fauteuil roulant électrique': 'fe',
    'Fauteuil roulant manuel': 'fm'
  },
  'Déficience visuelle': {
    'Partielle (malvoyant)': 'dv',
    'Totale (non-voyant)': 'dvt'
  },
  'Déficience auditive': {
    'Partielle (malentendant)': 'da',
    'Totale (sourd)': 'dat'
  },
  'Déficience mentale': {
    'Trouble intellectuel': 'dm',
    'Trouble psychique': 'mm',
  }
};

function getNested(obj, ...args) {
  return args.reduce((obj, level) => obj && obj[level], obj);
}

export const convertProfilForApiVal = (profil, condition) => {
  return getNested(profilMappingVal, profil, condition);
};


export const convertProfiltForApi = function(profil, condition){
  return getNested(profilMapping, profil, condition);
};

